import React from "react";

import { useClientConfigProvider } from "@/app/config/client-config-provider";
import Footer from "./footer";
import FooterV2 from "@/app/versioning/components/v2/FooterV2/footerv2";
import { useAppContext } from "@thriwe-2-0/thriwe-ui-utils";
import { usePathname } from "next/navigation";
import AppRoutes from "@/app/constants/routes";

function FooterComponent() {
  const { config } = useClientConfigProvider();
  const context = useAppContext();
  const pathname = usePathname();

  const {
    state: { selectedMembership },
  } = context;

  if (config?.designVersion === "v1") {
    return <Footer />;
  }

  if (config?.designVersion === "v2") {
    if (
      pathname === `${AppRoutes?.linkMembership}` &&
      !Boolean(Object.entries(selectedMembership?.data ?? {})?.length)
    ) {
      return <></>;
    } else {
      return <FooterV2 />;
    }
  }
}

export default FooterComponent;
